module.exports = __webpack_public_path__ + "assets/img/img68.e8d639f2.png";